import {ErrorCode} from "~/enums/errorHandling/errorCode";
import {IFlash} from "~/interfaces/flashInterfaces";
import ErrorHandler from "~/models/errorHandling/errorHandler";
import Model from "~/models/model";

export enum FlashMode {
  Banner = 1,
  Modal = 2,
}

export enum FlashStyle {
  Code = 1,
}

export let FlashHelper = {
  fromErrorCode: function(code: ErrorCode, model: Model): IFlash {
    const flash: IFlash = {}
    if (code) {
      flash.alert = new ErrorHandler({ code: code }, model).message;
    }
    return flash
  },
};
